import React from 'react'

import { PriceString } from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'

import type { Promotion } from '../../../../Promotions.types'
import { getPromotionTitle } from '../../../../utils/getPromotionTitle'
import { isShopPromotion } from '../../../../utils/isShopPromotion'
import * as S from './PromotionCodeTableCell.styled'

type PromotionCodeTableCellProps = {
  promotion: Promotion
}

export const PromotionCodeTableCell = ({ promotion }: PromotionCodeTableCellProps) => {
  const getDiscountType = () => {
    if (promotion.type === 'SINGLE' || promotion.type === 'MEMBERSHIPS_SINGLE') {
      return 'Promo code'
    }

    if (promotion.type === 'AUTO_APPLYING') {
      return 'Auto-applied'
    }

    return 'Multiple promo codes'
  }

  const getDiscountValue = () => {
    if (promotion.discount.type === 'FLAT_RATE') {
      return (
        <>
          <PriceString value={promotion.discount.money.value} /> off
        </>
      )
    }

    if (
      promotion.discount.type === 'PERCENTAGE' ||
      promotion.discount.type === 'MEMBERSHIPS_PERCENTAGE'
    ) {
      return `${promotion.discount.percentage}% off`
    }

    if (promotion.discount.type === 'FREE_SHIPPING') {
      return 'free shipping for'
    }

    return ''
  }

  const getDiscountProducts = () => {
    if (!isShopPromotion(promotion)) {
      return null
    }

    if (promotion.appliesTo.type === 'SELECTED_PRODUCTS' && promotion.appliesTo.products.length) {
      return `${pluralize(
        promotion.appliesTo.products.length,
        'a product',
        `${promotion.appliesTo.products.length} products`,
      )}`
    }

    return 'entire order'
  }

  const getTiers = () => {
    if (isShopPromotion(promotion)) {
      return null
    }

    if (promotion.appliesToTiers.type === 'MEMBERSHIPS_TIERS_ALL_TIERS') {
      return 'all membership tiers'
    }

    if (promotion.appliesToTiers.type === 'MEMBERSHIPS_TIERS_SELECTED_TIERS') {
      return 'selected membership tiers'
    }
  }

  const getRequirements = () => {
    if (!isShopPromotion(promotion)) {
      return undefined
    }

    if (promotion.requirements.minimumOrderValue?.value) {
      return (
        <>
          over <PriceString value={promotion.requirements.minimumOrderValue.value} />
        </>
      )
    }

    return undefined
  }

  return (
    <div>
      <S.Code>{getPromotionTitle(promotion)}</S.Code>
      <S.Summary>
        {getDiscountType()} for {getDiscountValue()} {getTiers()} {getDiscountProducts()}{' '}
        {getRequirements()}
      </S.Summary>
    </div>
  )
}
